<template>
  <div class="animated fadeIn">
    <filters :scope="filtersScope">
    </filters>
    <ringing-tabs/>

    <form  id="formCall"  @submit="checkForm">
      <div class="card">
        <div class="card-block">
          <div class="row">
            <div class="col-md-3">
              <table class="table">
                <tbody>
                <tr>
                  <td class="cel"><strong>Тариф смс: </strong> <input type="number" v-model="sms"></td>
                  <td class="cel"><strong>Стоимость 1 минуты: </strong><input type="number" v-model="call"> </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-3"></div>
            <div class="col-md-3"></div>
            <div class="col-md-3">
              <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6 apply-buttons">
                  <button class="btn btn-success btn-lg">
                    <i class="fa fa-check-circle"></i>
                    Сохранить
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
            <StatisticTable 
                :headColumns="headColumns"
                :footColumns="footColumns"
                :rows="rows"
                :title="`${$t('pages.sent_sms_template')}`">
            </StatisticTable>
  </div>
</template>

<script>
import Filters from '../../../../components/Filters'
import StatisticTable from '../../../../components/StatisticTable'
import API from '../../../../api/API'
import RingingTabs from './RingingTabs'
import {map} from 'lodash'
import Helper from '../../../../api/Helper'

export default {
  name: 'SentSmsTemplate',
  components: {RingingTabs, StatisticTable, Filters},
  data () {
    return {
      sms: 0,
      call: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true,
        byWmFilterAll: true
      },
      headColumns: [
        {label: this.$root.$t('statistic.template_sms'), field: 'template_sms', width: '1100px'},
        {label: this.$root.$t('statistic.parts_sms'), field: 'parts_sms', width: '110px'},
        {label: this.$root.$t('statistic.approvals'), field: 'approvals'},
        {label: this.$root.$t('statistic.sent_sms'), field: 'sent_sms'},
        {label: this.$root.$t('statistic.total_amount'), field: 'total_amount'},
        {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px'}
      ],
      rows: [],
      footColumns: {}
    }
  },
  mounted () {
    this.calculateRows()
    this.$root.$on('filters_load_new_data', () => {
      this.calculateRows()
    })
  },
  methods: {
    checkForm (e) {
      e.preventDefault()
      let rate = {
        sms: this.sms,
        call: this.call
      }
      API.postRingingRates(rate).then(response => {
        if (response.status === 200) {
          this.calculateRows()
        }
      }).catch(error => {
        console.log('Ошибка в запросе', error)
      })
    },
    calculateRows () {
      this.rows = []
      this.footColumns = {}
      API.getRingingRates().then(response => {
        this.sms = response.data.sms
        this.call = response.data.call
      })
      API.getTemplateSms().then(template => {
        let smsTemplates = template.body
        API.getSentSmsTemplate().then(response => {
          let sumTotal = 0
          let totalParts = 0
          let totalApproved = 0
          let totalSent = 0
          let totalAmount = 0
          let totalSpam = 0
          map(response.body, d => {
            sumTotal += d.total
            totalParts += d.parts
            totalApproved += d.approved
            totalSent += d.sent
            totalAmount += d.total_price
            totalSpam += d.span
            this.rows.push({
              template_sms: {
                value: Helper.getSmsText(smsTemplates, d.template_id)
              },
              parts_sms: {
                value: d.parts
              },
              approvals: {
                value: d.approved
              },
              sent_sms: {
                value: d.sent
              },
              total_amount: {
                value: '$ ' + (d.total_price).toFixed(2)
              },
              approvedFromValid: {
                value: d.total - d.spam > 0 ? Helper.approvedFromValid(d.approved, d.total, d.spam) : '0%'
              }
            })

            this.footColumns = {
              label: {
                value: this.$root.$t('statistic.in_total')
              },
              parts_sms: {
                value: totalParts
              },
              approvals: {
                value: totalApproved
              },
              sent_sms: {
                value: totalSent
              },
              total_amount: {
                value: '$ ' + totalAmount.toFixed(2)
              },
              approvedFromValid: {
                value: sumTotal - totalSpam > 0 ? Helper.approvedFromValid(totalApproved, sumTotal, totalSpam) : '0%'
              }
            }
          })
        })
      })
    }
  }
}
</script>

<style scoped>
input {
  outline: none;
  border: none;
  border-bottom: 1px solid #cfd8dc;
}

</style>



// WEBPACK FOOTER //
// SentSmsTemplate.vue?945317f2